import isElem from '../../scripts/util/isElement';
import $ from 'jquery';

const selectors = {
	promo: '.js--promocodeShare',
	promoCopy: '.js--promocodeCopy',
	promoText: '.js--promocodeText'
};

const fullBgImage = () => {
	const image = $('.js--fullImage');
	const img = new Image();
	img.src = image.data('src');
	img.onload = () => {
		image.addClass('is-load');
	};
};

const copyToClipboard = el => {
	const elem = $(el);
	const targetId = '_hiddenCopyText_';
	const isInput = elem;
	let origSelectionStart = '';
	let origSelectionEnd = '';
	let target = '';

	if (isInput) {
		target = elem;
		origSelectionStart = elem[0].selectionStart;
		origSelectionEnd = elem[0].selectionEnd;
	} else {
		target = $(targetId);
		if (!target) {
			target = $('textarea').append('body');
			target.css({position: 'absolute', top: '01', left: '-9999px'});
			target.attr('id', targetId);
		}
		target.val(elem.val());
	}

	const currentFocus = $(document.activeElement);
	target.focus();

	target[0].setSelectionRange(0, target.val().length);

	let succeed = '';
	try {
		succeed = document.execCommand('copy');
	} catch (e) {
		succeed = false;
	}

	if (currentFocus && typeof currentFocus.focus === 'function') {
		currentFocus.focus();
	}

	if (isInput) {
		elem[0].setSelectionRange(origSelectionStart, origSelectionEnd);
	} else {
		target.val('');
	}
	return succeed;
};

const clearMessage = () => {
	setTimeout(() => {
		$(selectors.promo).removeClass('is--copy');
	}, 4000);
};

const copyEvent = () => {
	$(selectors.promoCopy).on('click', function () {
		copyToClipboard(selectors.promoText);
		if (copyToClipboard(selectors.promoText)) {
			$(selectors.promo).addClass('is--copy');
			clearMessage();
		}
	});
};

const render = () => {
	if (isElem(selectors.promo)) {
		fullBgImage();
		copyEvent();
	}
};

export default render;
